import { render, staticRenderFns } from "./SpadPL_List.vue?vue&type=template&id=3cdc5f7a"
import script from "./SpadPL_List.vue?vue&type=script&lang=js"
export * from "./SpadPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports